<template>
  <div class="user-manage">
    <div class="list">
      <div class="title">
        <h1>总机构用户</h1>
        <div class="fun">
          <search placeholder="请输入姓名、用户名" @searchKeyChange="loadData" ref="search"></search>
          <div class="button">
            <a-button
              type="primary"
              size="large"
              @click="addOrgAccount"
            >创建用户</a-button>
          </div>
        </div>
      </div>
      <div class="table">
        <a-table
          :columns="columns"
          :data-source="data"
          bordered
          class="custom-table"
          :pagination="pagination" @change="tableChange" rowKey='_id'
        >
          <template slot="openid" slot-scope="text, record">
              <span v-if="record.openid" style="color: #2fae6f;">已绑定{{record.nickname ? `（${record.nickname}）`: ''}}</span>
              <span v-else>未绑定</span>
          </template>
          <template
            slot="is_disable"
            slot-scope="text, record"
          >
            <span :class="{fred:record.is_disable}">{{record.is_disable ? '是' : '否'}}</span>
          </template>
          <template
            slot="operation"
            slot-scope="text, record"
          >
            <a @click="editOrgAccount(record)">编辑</a>
            <a-divider type="vertical" />
            <a
              @click="openQrcode(record)"
            >绑定</a>
            <a-divider type="vertical" />
            <a
              @click="delOrgAccount(record)"
              v-if="!record.bind"
            >删除</a>
          </template>
        </a-table>
      </div>
    </div>
    <edit-org-user @confirmEdit='loadData'></edit-org-user>
    <delete-confirm @confirmDelete='confirmDeleteFun'></delete-confirm>
    <a-modal
      v-model="showwxbind"
      @ok="showwxbind=false"
      class="customermodel wxbindjguser-model"
      :footer="null"
      width="320px"
    >
      <div class="content">
        <div class="title">微信扫码绑定</div>
        <div class="qrcode">
          <qrcode-vue :value="qrcodeUrl" :size="160" level="H" class="reqr" />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import editOrgUser from '@/components/systemManage/EditOrgUser'
import deleteConfirm from '@/components/systemManage/DeleteConfirm'
import search from '@/components/common/Search'
import apis from '@/business/apis'
import { roleTypes } from '@/business/enums'
const columns = [
  {
    title: '姓名',
    dataIndex: 'real_name',
    width: 120
  },
  // {
  //   title: '用户名',
  //   dataIndex: 'name',
  //   width: 140
  // },
  {
    title: '角色',
    dataIndex: 'roleNames',
    width: 140
  },
  {
    title: '绑定状态',
    scopedSlots: { customRender: 'openid' },
    dataIndex: 'openid',
    width: 120
  },
  {
    title: '备注',
    dataIndex: 'desc',
    width: 180
  },
  {
    title: '是否禁用',
    dataIndex: 'is_disable',
    width: 90,
    scopedSlots: { customRender: 'is_disable' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: 132
  }
]
export default {
  inject: ['eventBus'],
  components: {
    editOrgUser,
    deleteConfirm,
    QrcodeVue,
    search
  },
  data () {
    return {
      showwxbind: false,
      qrcodeUrl: '',
      data: [],
      pagination: {
        current: 1
      },
      columns
    }
  },
  computed: {
    ...mapState('school', [
      'currentOrg'
    ]),
    ...mapState('user', [
      'currentUser'
    ])
  },
  methods: {
    openQrcode (record) {
      let cid = '5ff6c1f52ad06e0011b23bf6'
      if (window.location.host === 'canteen-k12.botwave.net') {
        cid = '5f59eefd8680920188948237'
      }
      this.qrcodeUrl = `https://${window.location.host}/wechat/${cid}/bind-wx/${record.id}`
      // this.qrcodeUrl = `https://canteen-k12.botwave.net/wechat/${cid}/bind-wx/${record.id}`
      this.showwxbind = true
    },
    async loadData () {
      let query = '?orgId=' + this.currentOrg._id + '&current=' + this.pagination.current
      if (this.$refs.search && this.$refs.search.searchKey) {
        query += ('&keyword=' + this.$refs.search.searchKey)
      }
      const response = await this.$http.get(apis.orgAdmin.list + query)
      this.data = response.body.list
      this.pagination = response.body.pagination

      this.data.forEach(user => {
        user.roleNames = this.getRoleNames(user.roles)
      })
    },
    getRoleNames (roles) {
      let result = ''
      roles && roles.forEach((item, index) => {
        result = index === 0 ? roleTypes[item] : result + '、' + roleTypes[item]
      })
      return result
    },
    tableChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.loadData()
    },
    addOrgAccount () {
      this.eventBus.$emit('show-editorguser-modal', true, {})
    },
    editOrgAccount (data) {
      this.eventBus.$emit('show-editorguser-modal', false, data)
    },
    delOrgAccount (data) {
      this.eventBus.$emit('show-deleteconfirm-modal', data.real_name, data)
    },
    async confirmDeleteFun (data) {
      const response = await this.$http.post(apis.orgAdmin.delete + data._id)
      if (response.body.success) {
        this.$message.success('删除成功')
        await this.loadData()
      }
    }
  },
  async created () {
    if (!this.currentUser.isOrgAdmin) {
      this.$router.back()
      return
    }
    await this.loadData()
  }
}
</script>

<style lang="less">
.user-manage {
  .list {
    border: 1px solid #e7e7eb;
    background: #fff;
    border-radius: 6px;
    padding: 0 16px;
    > .title {
      padding-top: 16px;
      display: flex;
      align-items: center;
      h1 {
        flex: 1;
        font-size: 20px;
      }
      .fun {
        display: flex;
        align-items: center;
        .search {
          .ant-input {
            height: 44px;
          }
          .anticon {
            font-size: 18px;
          }
        }
        .button {
          display: flex;
          align-items: center;
          .ant-btn {
            width: 110px;
            margin-left: 16px;
          }
        }
      }
    }
    .table {
      margin: 16px 0;
    }
  }
}
.edituser-model{
  .ant-form-item {
    margin-bottom: 32px;
    .ant-form-explain {
      position: absolute;
      top: 55px;
    }
  }
}
.wxbindjguser-model {
  .content {
    text-align: center;
    padding: 24px 0;
    .title {
      font-size: 16px;
    }
    .qrcode {
      border:1px solid #e8e8e8;
      width: 180px;
      height: 180px;
      margin: 12px auto;
      overflow: hidden;
      padding:10px;
    }
  }
}

</style>
